import { Pending } from "@indietabletop/appkit/async-op";
import { createContext } from "react";
import { EternolDB } from "../../lib/db";
import { DatabaseOpenRequestOp } from "./types";

export const eternol = new EternolDB();

// Expose on window to make it easier to debug IndexedDB
Object.assign(window, { eternol });

export const DatabaseContext = createContext(eternol);

export const DatabaseOpenRequest = createContext<DatabaseOpenRequestOp>(
  new Pending(),
);
